import { createFileRoute, useNavigate } from '@tanstack/react-router';

import {
  parseReceivingDeskSearch,
  type ReceivingDeskSearch,
} from '../../modules/receiving/receiving-desk-search.js';
import { ReceivingDesk } from '../../modules/receiving/receiving-desk.js';

export const Route = createFileRoute('/receiving/')({
  validateSearch: (search: Record<string, unknown>): ReceivingDeskSearch =>
    parseReceivingDeskSearch(search),
  component: ReceivingDeskRoute,
});

// eslint-disable-next-line react-refresh/only-export-components -- the route's component is private to this file
function ReceivingDeskRoute() {
  const navigate = useNavigate();
  const search = Route.useSearch();
  return (
    <ReceivingDesk
      search={search}
      onSearchChange={(patch) =>
        void navigate({
          from: '/receiving/',
          to: '/receiving',
          search: (previous) => ({ ...previous, ...patch }),
        })
      }
    />
  );
}
